import React from "react";
import { Image } from 'semantic-ui-react';
import './objectit_button.css';

const ObjectITButton = () => {
  return (
    <Image
      src="/developed-by-objectit.svg"
      as="a"
      href="http://objectit.com.au/"
      target="_blank"
      rel="noopener noreferrer"
      alt="Developed by Objectit"
      height="auto"
      className="sidebar-logo"
    />
  );
};

export default ObjectITButton;


// WEBPACK FOOTER //
// ./src/views/components/developed_by_objectit/objectit_button.js